// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divContainer[data-v-3be8fbc0]{height:100%}.fullContainer[data-v-3be8fbc0]{width:100%;height:100%}.cardHeader[data-v-3be8fbc0]{display:flex;justify-content:space-between;align-items:center}.smallFont[data-v-3be8fbc0]{font-size:12px}", ""]);
// Exports
module.exports = exports;
